import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 p-mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", null, "Detected frauds:", -1)
const _hoisted_3 = { class: "p-flex-column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", null, "By Status", -1)
const _hoisted_5 = { class: "campaign-name" }
const _hoisted_6 = { class: "campaign-name" }
const _hoisted_7 = { class: "campaign-name" }
const _hoisted_8 = { class: "campaign-name" }
const _hoisted_9 = { class: "campaign-name" }
const _hoisted_10 = { class: "campaign-name" }
const _hoisted_11 = { class: "campaign-name" }
const _hoisted_12 = { class: "campaign-name" }
const _hoisted_13 = { class: "p-flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_StatusChip = _resolveComponent("StatusChip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Dropdown, {
        modelValue: _ctx.selectedStatus,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStatus) = $event)),
        options: _ctx.statusFilterValues,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getDetectedFraudsWithFilter(_ctx.selectedStatus))),
        optionLabel: "name",
        optionValue: "value",
        placeholder: "Filter by alert status"
      }, null, 8, ["modelValue", "options"])
    ]),
    _createVNode(_component_DataTable, {
      value: _ctx.detectedFrauds,
      responsiveLayout: "scroll",
      class: "p-mt-6 w-75 w-100"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Flagged user",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(data.flaggedUserId.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "User e-mail",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(data.flaggedUserId.email), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "For Campaign",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_router_link, {
              to: { name: 'campaign', params: { campaignID: data.campaignId.id } },
              class: "p-d-flex p-align-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(data.campaignId.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Total installs (IOS + Android)",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(data.totalIOSInstallsCount + data.totalAndroidInstallsCount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Total clicks",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_9, _toDisplayString(data.totalClicksCount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Conversion rate",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_10, _toDisplayString(data.conversionRate), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Flag type",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_11, _toDisplayString(data.flagType), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Flagged tier",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_12, _toDisplayString(data?.campaignTier ?? "N/A"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Status",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_StatusChip, {
              status: _ctx.getStatusDisplayValue(data.dismissed),
              class: "p-mb-2",
              variant: "filled",
              color: "black"
            }, null, 8, ["status"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Actions",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Button, {
                disabled: data.dismissed,
                label: "Dismiss",
                onClick: ($event: any) => (_ctx.dismissFraudAlert(data.id))
              }, null, 8, ["disabled", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}